import {IWebBanner} from "../interfaces/IWebBanner";
import styled from "styled-components";
import {getTheme} from "../shared/themeUtils";
import Link from "next/link";

const BannerContainer = styled.div`
    text-align: center;
    margin: ${getTheme("space.3")} 0;

    img {
        max-height: 300px;
        max-width: 100%;
    }
`;

export default function WebBanner({banner}: { banner: IWebBanner[] | IWebBanner }) {
    const bannerData = Array.isArray(banner) ? banner[0] : banner;

    if (!bannerData || !bannerData.image?.src) return null;
    return (
        <BannerContainer>
            {bannerData.link?.href ? (
              <Link href={`/${bannerData.link.href}`}>
                    <img
                        src={bannerData.image.src}
                        alt={bannerData.image.title || "Banner"}
                    />
                </Link>
            ) : (
                <img
                    src={bannerData.image.src}
                    alt={bannerData.image.title || "Banner"}
                />
            )}
        </BannerContainer>
    );
}
